const tooltips = {
  getTooltip(keyword) {
    switch (keyword) {
      case 'Business Website': 
        return 'URL link to website if applicable'
      case 'Use of Proceeds': 
        return 'This section should have a detailed breakdown of how the customer will use the loan. Allocations should match those in the application detail section. If necessary, please detail UOP for any loans that we are refinancing.'
      case 'Trends': 
        return 'This section should include detailed explanation to YoY changes in Revenue, Expenses or Margins.'
      case 'Financial Statements': 
        return 'This section should include any clarification of the financial statements that is necessary to understanding the credit story. For example, commentary on Accounts Receivable if it is significantly high in comparison to revenue or clarification on Other Liabilities if significant.'
      case 'Personal Financial Statements': 
        return 'This section should clarify line items on the PFS if necessary to understanding the credit story.'
      case 'CBR': 
        return 'This section should include explanations for items on the Credit Report that have a material impact on the credit story. Topics might include bankruptcy explanations, recent late payments, commentary on high revolving debt & notes on recent inquiries.'
      case 'Affiliation': 
        return 'This section should include commentary on affiliates if applicable. This section can serve as a place to explain the relationship between entities that will either mitigate or necessitate co-borrow or corporate guarantee structure.'
      case 'Location / Address Clarification': 
        return 'This section should serve as a place to clarify discrepancies or confusion regarding business and/or guarantor location & address.'
      case 'Documentation Clarification': 
        return 'This section should serve as a place to clarify discrepancies or confusion in various documentation.'
      case 'UCC Reconciliation': 
        return 'This section should include reconciliation of your UCC. You should list out each active UCC and either identify it with a debt on the debt schedule or notate that you will be pursuing termination if required by the lender.'
      default: 
        return ''
    }
  }
}

export default tooltips